module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((!_vm.isLoading && _vm.list.length > 0) || _vm.filterSelected) ? _c('div', {
    staticClass: "filter-type is-flex"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex-1"
  }, _vm._l((_vm.filterTypes), function(o) {
    return _c('div', {
      staticClass: "tag",
      class: {
        'selected': o.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectTypeFilter(o)
        }
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "events-super-container",
    style: ('max-height: ' + _vm.maxHeightStyle)
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTopShadow),
      expression: "showTopShadow"
    }],
    staticClass: "box-shadow-container top box-shadow-container-top"
  }), _c('div', {
    staticClass: "info-miner w100 event-container",
    class: {
      'infinite-container': _vm.infiniteScroll
    },
    style: ('max-height: ' + _vm.maxHeightStyle),
    attrs: {
      "id": "event-container"
    }
  }, [(!_vm.isLoading && _vm.list.length === 0) ? _c('div', {
    staticClass: "result-no-payments pos-r padding-no-results has-text-left"
  }, [(_vm.filterSelected) ? _c('span', [_vm._v("There are no events with the current filters.")]) : _c('span', [_vm._v("You have no live updating data, yet.")])]) : _vm._e(), _c('div', {
    staticClass: "live-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "live-item",
      class: {
        'animate-long': item.updated
      }
    }, [_c('div', {
      staticClass: "live-icon"
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon,
      style: ({
        color: item.iconColor
      })
    })]), _c('div', {
      staticClass: "live-description"
    }, [(item.version == 2) ? [(item.type == 'reward') ? [_c('div', {
      staticClass: "amount-large"
    }, [(item.amount_extended) ? [_c('span', [_vm._v(_vm._s(item.amount))]), _c('span', {
      staticClass: "extended_amount"
    }, [_vm._v(_vm._s(item.amount_extended.replace(item.amount, '')) + " ")])] : [_c('span', [_vm._v(_vm._s(item.amount) + " ")])], _c('img', {
      attrs: {
        "src": _vm.coinLogo,
        "alt": _vm.coin + ' logo'
      }
    })], 2), _c('div', {
      staticClass: "reward-desc"
    }, [_c('span', [_vm._v("Received over the past " + _vm._s(_vm._f("toMinutes")(item.time_diff)) + " minutes ")]), _c('div', {
      staticClass: "is-hidden-tablet-only is-hidden-desktop-only is-hidden-widescreen-only is-hidden-fullhd"
    }, [_vm._v(_vm._s(item.time_info))]), _c('span', {
      staticClass: "is-hidden-mobile hint--top",
      attrs: {
        "aria-label": item.time_info
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle"
    })])])] : _vm._e()] : [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })], _c('div', {
      staticClass: "live-date"
    }, [_c('span', {
      staticClass: "w100 s12"
    }, [_vm._v(_vm._s(_vm._f("formatDateSecond")(item.timestamp)))])])], 2), (item.type !== 'reward') ? _c('div', {
      staticClass: "live-external-link",
      on: {
        "click": function($event) {
          return _vm.goToEvent(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link-square"
    })]) : _vm._e()])
  }), 0), (_vm.isLoading && !_vm.isLoadingParent) ? _c('div', {
    staticClass: "fs-13 text-white-on-dark has-text-centered is-loading"
  }, [_vm._v("Loading...")]) : _vm._e(), (!_vm.isLoading && !_vm.infiniteScroll && _vm.list.length > 0 && !_vm.noMoreFetch) ? _c('div', {
    staticClass: "more-events has-text-centered"
  }, [_c('div', {
    staticClass: "info-link",
    on: {
      "click": _vm.loadMoreEvents
    }
  }, [_c('span', [_vm._v("View more events")])]), _c('span', {
    staticClass: "more-events-subtitle"
  }, [_vm._v("Events are kept for up to 7 days")])]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBottomShadow),
      expression: "showBottomShadow"
    }],
    staticClass: "box-shadow-container bottom box-shadow-container-bottom"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-tag"
  }, [_c('span', [_vm._v("Filter by type:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02066e88","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_live_events.vue
// module id = 353
// module chunks = 1